<template>
    <el-dialog
        :class="['yl_dialog', {'yl_custom_dialog': dialogTitleDate && dialogTitleDate.type == 'hidden'}]"
        v-bind="dialogAttributes"
        :visible.sync="visible"
        :before-close="handleClose"
        :append-to-body="appendToBody"
        top="13vh"
    >
        <div slot="title" class="yl_dialog_title" v-if="titleStyle">
            <span :class="['ft24', titleStyle.icon, titleStyle.color]"></span>
            <span class="pl16">{{titleStyle.title}}</span>
        </div>
        <slot></slot>
        <template v-if="$slots.footer">
            <slot slot="footer" name="footer"></slot>
        </template>
    </el-dialog>
</template>

<script>
    export default {
        name: 'yl-lc-dialog',
        props: {
            attributes: {
                type: Object,
                default: ()=>{
                    return {
                        title: "标题"
                    }
                }
            },
            dialogTitleDate: {
                type: Object,
                default: null
            },
            beforeClose: null,
            appendToBody:{
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                visible:false,
                dialogAttributes: {},
                titleData: [
                    {type: 'success', icon: "el-icon-success", title: "提示", color: "successTextColor"},
                    {type: 'warning', icon: "el-icon-warning", title: "提示", color: "warningTextColor"},
                    {type: 'error', icon: "el-icon-error", title: "提示", color: "dangerTextColor"},
                ]
            };
        },
        computed: {
            titleStyle() {
                if(!this.dialogTitleDate){
                    return null
                }
                let isTrue = this.titleData.some(itm=>{return itm.type == this.dialogTitleDate.type})
                if(isTrue){
                    let obj = this.titleData.find(itm=>{return itm.type == this.dialogTitleDate.type})
                    for (const n in this.dialogTitleDate) {
                        obj[n] = (this.dialogTitleDate[n] && this.dialogTitleDate[n] != '') ? this.dialogTitleDate[n] : obj[n]
                    }
                    return obj
                }else{
                    return null
                }
            },
        },
        watch:{
            
        },
        mounted(){
            this.dialogAttributes = {
                ...this.attributes,
                ...this.$attrs
            }
        },
        methods: {
            handleClose(done){
                if(typeof this.beforeClose === 'function'){
                    this.beforeClose(done)
                }else{
                    this.visible = false
                }
            },
        }
    };
</script>

<style lang="less">
.yl_dialog{
    .el_dialog__body{
        padding-bottom: 24px;
    }
    .el_dialog__footer{
        margin-top: 24px;
    }
}
</style>